import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

//Post Override Request
const postOverrideRequestPending = (state: AppState) => state.postOverrideRequest.pending;
const postOverrideRequest = (state: AppState) => state.postOverrideRequest.override;
const postOverrideRequestError = (state: AppState) => state.postOverrideRequest.error;

export const postOverrideRequestSelector = createSelector(postOverrideRequest, (overrides) => overrides);
export const postOverrideRequestPendingSelector = createSelector(postOverrideRequestPending, (pending) => pending);
export const postOverrideRequestErrorSelector = createSelector(postOverrideRequestError, (error) => error);

//Patch Override Request
const patchOverrideRequestPending = (state: AppState) => state.patchOverrideRequest.pending;
const patchOverrideRequest = (state: AppState) => state.patchOverrideRequest.success;
const patchOverrideRequestError = (state: AppState) => state.patchOverrideRequest.error;

export const patchOverrideRequestSelector = createSelector(patchOverrideRequest, (overrides) => overrides);
export const patchOverrideRequestPendingSelector = createSelector(patchOverrideRequestPending, (pending) => pending);
export const patchOverrideRequestErrorSelector = createSelector(patchOverrideRequestError, (error) => error);

//Fetch Override Request
const fetchOverrideRequestPending = (state: AppState) => state.fetchOverrideRequest.pending;
const fetchOverrideRequest = (state: AppState) => state.fetchOverrideRequest.override;
const fetchOverrideRequestError = (state: AppState) => state.fetchOverrideRequest.error;

export const fetchOverrideRequestSelector = createSelector(fetchOverrideRequest, (overrides) => overrides);
export const fetchOverrideRequestPendingSelector = createSelector(fetchOverrideRequestPending, (pending) => pending);
export const fetchOverrideRequestErrorSelector = createSelector(fetchOverrideRequestError, (error) => error);


//Fetch Override Request List
const getOverrideRequestListPending = (state: AppState) => state.overrideRequests.pending;
const getOverrideRequestList = (state: AppState) => state.overrideRequests.overrideRequests;
const getOverrideRequestListError = (state: AppState) => state.overrideRequests.error;

export const getOverrideRequestListSelector = createSelector(getOverrideRequestList, (overrideRequests) => overrideRequests);
export const getOverrideRequestListPendingSelector = createSelector(getOverrideRequestListPending,(pending) => pending);
export const getOverrideRequestListErrorSelector = createSelector(getOverrideRequestListError, (error) => error);
